export default class Lamp {
	constructor(scene, offsetX, offsetY) {
		this.scene = scene;
		this.lamp = scene.addSpriteLocPos('lamp_off', offsetX, offsetY);
	}

	on() {
		this.lamp.setTexture('lamp_on');
	}

	off() {
		this.lamp.setTexture('lamp_off');
	}

	setOn(lampOn) {
		this.lamp.setTexture(lampOn ? 'lamp_on' : 'lamp_off');
	}
}
